export const StorageKeys = {
    AUTH_USER: 'auth_user',
    ACCESS_TOKEN: 'access_token',
    REFRESH_TOKEN: 'refresh_token',
    PERMISSIONS: 'permissions',
    ORG_ID: 'org_id',
    PATIENT_ID: 'patient_id',
    LICENSE_USAGE_ID: 'license_usage_id',
    DEVICE_USER_ID: 'device_user_id',
    LICENSE_KEY: 'licenseKey',
    TOKEN: 'token'
} as const;

export const setAuthData = (response: {
    user: any;
    accessToken: string;
    refreshToken: string;
    permissions: string;
    patient_id: string;
    org_id: string;
}) => {
    localStorage.setItem(StorageKeys.AUTH_USER, JSON.stringify(response.user));
    localStorage.setItem(StorageKeys.ACCESS_TOKEN, response.accessToken);
    localStorage.setItem(StorageKeys.REFRESH_TOKEN, response.refreshToken);
    localStorage.setItem(StorageKeys.PERMISSIONS, response.permissions);
    localStorage.setItem(StorageKeys.PATIENT_ID, response.patient_id);
    localStorage.setItem(StorageKeys.ORG_ID, response.org_id);
};

export const clearAuthData = () => {
    localStorage.removeItem(StorageKeys.AUTH_USER);
    localStorage.removeItem(StorageKeys.ACCESS_TOKEN);
    localStorage.removeItem(StorageKeys.REFRESH_TOKEN);
    localStorage.removeItem(StorageKeys.PERMISSIONS);
    localStorage.removeItem(StorageKeys.PATIENT_ID);
    localStorage.removeItem(StorageKeys.ORG_ID);
    localStorage.removeItem(StorageKeys.LICENSE_USAGE_ID);
    localStorage.removeItem(StorageKeys.DEVICE_USER_ID);
    localStorage.removeItem(StorageKeys.LICENSE_KEY);
    localStorage.removeItem(StorageKeys.TOKEN);
};

export const getStoredAuthData = () => {
    const user = localStorage.getItem(StorageKeys.AUTH_USER);
    const token = localStorage.getItem(StorageKeys.ACCESS_TOKEN);
    const refreshToken = localStorage.getItem(StorageKeys.REFRESH_TOKEN);
    const permissions = localStorage.getItem(StorageKeys.PERMISSIONS);
    const patient_id = localStorage.getItem(StorageKeys.PATIENT_ID);
    const org_id = localStorage.getItem(StorageKeys.ORG_ID);

    return {
        user: user ? JSON.parse(user) : null,
        token,
        refreshToken,
        permissions,
        patient_id,
        org_id,
        isAuthenticated: !!token
    };
};